var _path, _ellipse, _ellipse2, _circle, _ellipse3, _ellipse4, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompany3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 314,
    height: 63,
    viewBox: "0 0 314 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M249.562 32.3242L250.031 34.5731C250.98 39.127 254.773 42.539 259.402 43.0019L259.637 43.0254C262.42 43.3038 265.195 42.4163 267.3 40.5742V40.5742",
    stroke: "#888888",
    strokeWidth: 7.425,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.5125,
    cy: 38.5125,
    rx: 23.5125,
    ry: 21.45,
    fill: "#888888"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.2633,
    cy: 22.425,
    rx: 24.3375,
    ry: 21.8625,
    fill: "#888888"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 78.7871,
    cy: 38.9258,
    r: 14.4375,
    fill: "#888888"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 62.2883,
    cy: 48.4117,
    rx: 13.6125,
    ry: 14.025,
    fill: "#888888"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.6633,
    cy: 41.8121,
    rx: 13.6125,
    ry: 14.025,
    fill: "#888888"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M117.975 19.5371V31.6743C117.975 35.426 119.867 38.9245 123.007 40.9776V40.9776C126.501 43.2621 130.992 43.3897 134.616 41.3186V41.3186C138.093 39.332 140.25 35.6285 140.25 31.6243V19.5371",
    stroke: "#888888",
    strokeWidth: 7.425,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M179.025 43.0508V30.9136C179.025 27.1619 177.133 23.6634 173.993 21.6103V21.6103C170.499 19.3258 166.008 19.1982 162.384 21.2693V21.2693C158.907 23.2559 156.75 26.9594 156.75 30.9636V43.0508",
    stroke: "#888888",
    strokeWidth: 7.425,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M309.375 43.0508V30.9136C309.375 27.1619 307.483 23.6634 304.342 21.6103V21.6103C300.849 19.3258 296.358 19.1982 292.733 21.2693V21.2693C289.257 23.2559 287.1 26.9594 287.1 30.9636V43.0508",
    stroke: "#888888",
    strokeWidth: 7.425,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M195.525 19.5371L195.525 43.4621",
    stroke: "#888888",
    strokeWidth: 7.425,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M235.125 19.5371L211.2 19.5371",
    stroke: "#888888",
    strokeWidth: 7.425,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M235.125 19.5371L212.025 42.6371",
    stroke: "#888888",
    strokeWidth: 7.425,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M235.125 42.6367L212.025 42.6367",
    stroke: "#888888",
    strokeWidth: 7.425,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M272.662 31.9121L249.568 31.9121",
    stroke: "#888888",
    strokeWidth: 7.425,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M272.662 31.9117L271.475 27.7555C270.65 24.8679 268.722 22.4209 266.107 20.9431L265.601 20.6572C262.545 18.9295 258.821 18.867 255.708 20.4912V20.4912C252.872 21.971 250.878 24.678 250.305 27.8257L249.562 31.9117",
    stroke: "#888888",
    strokeWidth: 7.425,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany3);
export default __webpack_public_path__ + "static/media/company3.6405c926bfda32925058fe356c0e3505.svg";
export { ForwardRef as ReactComponent };